"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStorageLocale = exports.getStorageLocale = void 0;
var LOCALE_STORAGE_ID = 'locale';
function getStorageLocale() {
    return localStorage.getItem(LOCALE_STORAGE_ID);
}
exports.getStorageLocale = getStorageLocale;
function setStorageLocale(localeId) {
    localStorage.setItem(LOCALE_STORAGE_ID, localeId);
}
exports.setStorageLocale = setStorageLocale;
